// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Mw8C","footer":"ModalFilter_footer__28KqP"};